import { Heading } from "arag-ui-lib"
import CONTENT_STRINGS from "../../../helpers/contentStrings";
import { HEADING_3 } from "../../../helpers/constants";
//'application-premium-settings-stage-a'
const StagesDescription = (props) => {
    const {
        stageATestId,
        stageBTestId,
        stageCTestId,
    } = props;
    return (
        <div>
            <Heading 
                variant={HEADING_3}
                title={CONTENT_STRINGS.STAGE_A_TITLE} 
                headingTestId={stageATestId}
            />
            <Heading 
                variant={HEADING_3}
                title={CONTENT_STRINGS.STAGE_B_TITLE} 
                headingTestId={stageBTestId}
            />
            <Heading 
                variant={HEADING_3}
                title={CONTENT_STRINGS.STAGE_C_TITLE}
                headingTestId={stageCTestId}
            />
        </div>
    )
}
export default StagesDescription;